export function getIcon({ folder_name, file_extension }) {
  if (folder_name) return `url("${new URL('@/assets/folder_icon.svg', import.meta.url)}")`;
  switch (file_extension) {
    case 'pdf':
    case '.pdf':
      return `url("${new URL('@/assets/pdf_icon.svg', import.meta.url)}")`;
    case 'doc':
    case '.doc':
    case 'docx':
    case '.docx':
      return `url("${new URL('@/assets/doc_icon.svg', import.meta.url)}")`;
    case 'xls':
    case '.xls':
    case 'xlsx':
    case '.xlsx':
    case 'csv':
    case '.csv':
    case 'tsv':
    case '.tsv':
      return `url("${new URL('@/assets/xls_icon.svg', import.meta.url)}")`;
    case 'jpg':
    case '.jpg':
    case 'png':
    case '.png':
    case 'jpeg':
    case '.jpeg':
      return `url("${new URL('@/assets/image_icon.svg', import.meta.url)}")`;
    case 'mp4':
    case '.mp4':
      return `url("${new URL('@/assets/video.svg', import.meta.url)}")`;
    case 'pptx':
    case '.pptx':
    case 'ppt':
    case '.ppt':
      return `url("${new URL('@/assets/pptx_icon.svg', import.meta.url)}")`;
    case 'zip':
    case '.zip':
      return `url("${new URL('@/assets/zip_icon.svg', import.meta.url)}")`;
    case 'link':
      return `url("${new URL('@/assets/link_icon.svg', import.meta.url)}")`;
    case 'gdrive':
      return `url("${new URL('@/assets/google_drive_icon.svg', import.meta.url)}")`;
    default:
      return `url("${new URL('@/assets/default_doc_icon.svg', import.meta.url)}")`;
  }
}

export function getGlobalSearchIcon(file_extension) {
  switch (file_extension) {
    case 'pdf':
    case '.pdf':
      return `url("${new URL('@/assets/search-icons/pdf.svg', import.meta.url)}")`;
    case 'doc':
    case '.doc':
    case 'docx':
    case '.docx':
      return `url("${new URL('@/assets/search-icons/default_doc.svg', import.meta.url)}")`;
    case 'xls':
    case '.xls':
    case 'xlsx':
    case '.xlsx':
    case 'csv':
    case '.csv':
    case 'tsv':
    case '.tsv':
      return `url("${new URL('@/assets/search-icons/xls.svg', import.meta.url)}")`;
    case 'svg':
    case '.svg':
    case 'jpg':
    case '.jpg':
    case 'png':
    case '.png':
    case 'jpeg':
    case '.jpeg':
      return `url("${new URL('@/assets/search-icons/image.svg', import.meta.url)}")`;
    case 'mp4':
    case '.mp4':
      return `url("${new URL('@/assets/search-icons/video.svg', import.meta.url)}")`;
    case 'mp3':
    case '.mp3':
    case 'wav':
    case '.wav':
    case 'aac':
    case '.aac':
      return `url("${new URL('@/assets/search-icons/audio.svg', import.meta.url)}")`;
    case 'pptx':
    case '.pptx':
    case 'ppt':
    case '.ppt':
      return `url("${new URL('@/assets/search-icons/ppt.svg', import.meta.url)}")`;
    case 'zip':
    case '.zip':
      return `url("${new URL('@/assets/search-icons/zip.svg', import.meta.url)}")`;
    case 'link':
      return `url("${new URL('@/assets/search-icons/advanced-search-link.svg', import.meta.url)}")`;
    default:
      return `url("${new URL('@/assets/search-icons/default_doc.svg', import.meta.url)}")`;
  }
}
